import React, { useCallback } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { Link, useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";

import { InputField } from "affinityForm/fields";
import { Button } from "affinityUI/elements/button";
import { Grid } from "affinityUI/elements/grid";
import { Layout } from "affinityUI/structures/layout";
import { useRequest } from "lib/api";
import { Yup } from "lib/extendYup";

const validationSchema = Yup.object().shape({
  email: Yup.string().required("Email is required"),
});

export const RecoverPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const { showBoundary: onError } = useErrorBoundary();

  const [, requestPassword] = useRequest(
    {
      url: "/password_reset/",
      method: "POST",
    },
    {
      manual: true,
    }
  );
  const handleSubmit = useCallback(
    (formData) => {
      requestPassword({ data: { ...formData } })
        .then(() => {
          navigate("success");
        })
        .catch((error) => {
          onError(error);
        });
    },
    [onError, navigate, requestPassword]
  );

  return (
    <Layout title="Recover password" publicLayout>
      <Formik
        enableReinitialize
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={validationSchema}
        initialValues={{}}
        onSubmit={handleSubmit}
      >
        <Form>
          <Grid $tight>
            <p>Please enter your username you will be sent a new link to reset your password.</p>
            <InputField name="email">Email</InputField>
            <Button type="submit">Send recovery link</Button>
            <Link to="../..">Back to login</Link>
          </Grid>
        </Form>
      </Formik>
    </Layout>
  );
};
